const planLimitMessage = (error) => {
  const data = error?.response?.data;
  const body = data?.code === "plan_limit" ? data : data?.detail;
  return body?.code === "plan_limit" ? body.message : null;
};

export const withPlanLimitMessage = (fallback, error) => {
  const message = planLimitMessage(error);
  return message ? `${fallback}: ${message}` : fallback;
};

export default planLimitMessage;
